import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Packages from '@/components/Packages'
import Prealert from '@/components/Prealert'
import Prealert_form from '@/components/Prealert-form'
import Notification from '@/components/Notification'
import Office from '@/components/Office'
import PackageDetails from '@/components/PackageDetails'
import PackageSignature from '@/components/PackageSignature'
import Chats from '@/components/Chats'
import Emergencies from '@/components/Emergencies'
import Signup from '@/components/Signup'
import Profile from '@/components/Profile'
import Delivery from '@/components/Delivery'
import DeliveryForm from '@/components/DeliveryForm'
import Help from '@/components/Help'

import Store from '../store/'

Vue.use(Router)
const appRouter = new Router({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Login',
    component: Login,
    beforeEnter: (to, from, next) => {
      if (Store.getters.login === false) {
        next()
      } else {
        next('/packages')
      }
    }
  },
    {
      path: '/signup',
      name: 'Signup',
      component: Signup,
      beforeEnter: (to, from, next) => {
        if (Store.getters.login === false) {
          next()
        } else {
          next('/packages')
        }
      }
    },
  {
    path: '/packages',
    name: 'Packages',
    component: Packages,
    beforeEnter: (to, from, next) => {
      if (Store.getters.login === false) {
        next('/')
      } else {
        next()
      }
    }
  },
    {
      path: '/prealert',
      name: 'Prealert',
      component: Prealert,
      beforeEnter: (to, from, next) => {
        if (Store.getters.login === false) {
          next('/')
        } else {
          next()
        }
      }
    },
    {
      path: '/prealert-form',
      name: 'Prealert form',
      component: Prealert_form,
      beforeEnter: (to, from, next) => {
        if (Store.getters.login === false) {
          next('/')
        } else {
          next()
        }
      }
    },
    
    {
      path: '/office',
      name: 'Office',
      component: Office,
      beforeEnter: (to, from, next) => {
        if (Store.getters.login === false) {
          next('/')
        } else {
          next()
        }
      }
    },{
      path: '/delivery',
      name: 'Delivery',
      component: Delivery,
      beforeEnter: (to, from, next) => {
        if (Store.getters.login === false) {
          next('/')
        } else {
          next()
        }
      }
    }, {
      path: '/delivery-form',
      name: 'delivery-form',
      component: DeliveryForm,
      beforeEnter: (to, from, next) => {
        if (Store.getters.login === false) {
          next('/')
        } else {
          next()
        }
      }
    }, {
      path: '/profile',
      name: 'Profile',
      component: Profile,
      beforeEnter: (to, from, next) => {
        if (Store.getters.login === false) {
          next('/')
        } else {
          next()
        }
      }
    },{
      path: '/notification',
      name: 'Notification',
      component: Notification,
      beforeEnter: (to, from, next) => {
        if (Store.getters.login === false) {
          next('/')
        } else {
          next()
        }
      }
    },
  
  {
    path: '/PackageDetails/:id',
    name: 'PackageDetails',
    component: PackageDetails,
    props: true,
    beforeEnter: (to, from, next) => {
      if (Store.getters.login === false) {
        next('/')
      } else {
        next()
      }
    }
  },
  {
    path: '/PackageSignature/:selectOwner',
    name: 'PackageSignature',
    component: PackageSignature,
    props: true,
    beforeEnter: (to, from, next) => {
      if (Store.getters.login === false) {
        next('/')
      } else {
        next()
      }
    }
  },
  {
    path: '/chats',
    name: 'Chats',
    component: Chats,
    beforeEnter: (to, from, next) => {
      if (Store.getters.login === false) {
        next('/')
      } else {
        next()
      }
    }
  },
  {
    path: '/emergencies',
    name: 'Emergencies',
    component: Emergencies,
    beforeEnter: (to, from, next) => {
      if (Store.getters.login === false) {
        next('/')
      } else {
        next()
      }
    }
  },
  {
    path: '/help',
    name: 'Help',
    component: Help, 
    beforeEnter: (to, from, next) => {
      if (Store.getters.login === false) {
        next('/')
      } else {
        next()
      }
    }
  },
  
  ]
})

export default appRouter
